import React from 'react';
import { createContextForController } from 'react-controller-context';
import { find, uniqBy } from 'lodash';
import { useStudents } from './use-students';

const useController = () => {
    const { students } = useStudents();
    const [ selectedStudents, setSelectedStudents ] = React.useState([]);
    
    //  New students list?  just select them all!
    React.useEffect(() => {
        setSelectedStudents(students);
    }, [students]);

    const isStudentSelected = React.useCallback((student) => {
        return Boolean(find(selectedStudents, { id: student.id }));
    }, [selectedStudents ]);
    
    const toggleStudentSelection = React.useCallback((student, enabled) => {
        setSelectedStudents(students => {
            const s = students.filter(s => s.id !== student.id);
            if (enabled) {
                s.push(student);
            }
            return s;
        });
    }, [selectedStudents]);

    const addStudents = React.useCallback((students) => {
        setSelectedStudents(selectedStudents => {
            return uniqBy([...selectedStudents, ...students], 'id');
        });
    }, []);
    const removeStudents = React.useCallback((students) => {
        setSelectedStudents(selectedStudents => {
            return selectedStudents.filter(s => !students.find(s2 => s2.id === s.id));
        });
    }, []);

    return {
        selectedStudents,
        setSelectedStudents,
        toggleStudentSelection,
        isStudentSelected,
        addStudents,
        removeStudents
    };
};

const context = createContextForController(useController);
export const SelectedStudentsProvider = context.Provider;
export const useSelectedStudents = context.useController;